module.exports = __webpack_public_path__ + "img/logo-fomapo.f9b197da.png";